module.exports = __webpack_public_path__ + "static/img/02.affb7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/02.png
// module id = pjnX
// module chunks = 2